import { Heading } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import PageInfo from '../../components/PageInfo/PageInfo';
import ContentArea from '../../ContentArea';
import { Kalenderhändelse } from '../../types/pages';
import { ContentResponse } from '../../types/shared';
import XhtmlText from '../../XhtmlText';
import styles from './KalenderhändelseSida.module.css';

type KalenderhändelseSidaProps = {
  contentResponse: ContentResponse;
};

const KalenderhändelseSida: FC<KalenderhändelseSidaProps> = ({
  contentResponse,
}): ReactNode => {
  const standardsida = contentResponse.content as Kalenderhändelse;

  return (
    <div className={styles.standardsida}>
      <PageInfo variant={standardsida.döljPubliceringsdatum ? 'breadcrumbs' : 'both'} contentResponse={contentResponse}></PageInfo>

      <header>
        {standardsida.rubrik && <Heading headingLevel={1}>{standardsida.rubrik}</Heading>}
      </header>
      {standardsida.textytan && <XhtmlText xhtmlResponse={standardsida.textytan} />}
      <div>
        {standardsida.blockytan && <ContentArea contentAreaResponse={standardsida.blockytan} />}
      </div>
    </div>
  );
};

export default KalenderhändelseSida;
